import { required, max, integer, min_value } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';
import i18n from '../locale';

extend('required', {
	...required,
	message: i18n.t('error.thisFieldIsRequired')
});

extend('max', {
	...max,
	message: 'This field must be {length} characters or less'
});

extend('integer', {
	...integer,
	message: 'This field must be an integer'
});

extend('min_value', {
	...min_value,
	message: 'This field must be {min} or greater'
});
